import * as Yup from 'yup';

import { http } from 'lib/services/http';
import { platformAdminBaseUrl } from 'constants/apiUrls';
import { yupErrorHandler } from 'api/apiUtils';

const OLD_ROLES_API_PATH = `${platformAdminBaseUrl}/roles`;
const ROLES_API_PATH = `${platformAdminBaseUrl}/macroroles`;

// get list of roles
export const getRoles = (params = '') => {
  return http.get(`${OLD_ROLES_API_PATH}/search${params}`, {});
};

const payloadModel = Yup.object()
  .shape({
    name: Yup.string().strict().required(),
    permissions: Yup.array().of(
      Yup.object().shape({
        resource_id: Yup.string().required(),
        value: Yup.lazy((value) => {
          if (Array.isArray(value)) {
            return Yup.array().of(Yup.number().integer()).min(3);
          }

          return Yup.object().required();
        }),
      }),
    ),
  })
  .required();

// create a new role
export const createRole = (payload) => {
  return payloadModel
    .validate(payload)
    .then(() => {
      return http.post(`${ROLES_API_PATH}`, payload);
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

// get the details for a single role
export const getRole = (roleName: string) => {
  return http.get(`${ROLES_API_PATH}/${roleName}/retrieve`);
};

// deactivate a role
export const deleteRole = (roleName: string) => {
  return http.delete(`${OLD_ROLES_API_PATH}/${roleName}/delete`);
};

const rolePayloadModel = Yup.object()
  .shape({
    name: Yup.string().strict().required(),
    permissions: Yup.array().of(
      Yup.object().shape({
        resource_id: Yup.string().required(),
        value: Yup.lazy((value) => {
          if (Array.isArray(value)) {
            return Yup.array().of(Yup.number().integer()).min(3);
          }

          return Yup.object().required();
        }),
      }),
    ),
  })
  .required();

// Edit the permissions of a role
export const updateRole = (name: string, payload) => {
  return rolePayloadModel
    .validate(payload)
    .then(() => {
      return http.put(`${ROLES_API_PATH}/${name}`, {
        name: payload.name,
        permissions: payload.permissions,
      });
    })
    .catch((err) => {
      throw yupErrorHandler(err.errors);
    });
};

// Get Macro template by name
export const getMacroTemplate = (name: string) => {
  return http.get(`${platformAdminBaseUrl}/macrotemplates/${name}`);
};
